import { Component, ViewContainerRef } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { Field } from '../../models/field.interface';
import { FieldConfig } from '../../models/field-config.interface';
import { MatFormFieldControl } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { RxIconModule } from '@nrwl/rx-icon';

@Component({
  selector: 'app-form-input',
  styleUrls: ['form-input.component.scss'],
  templateUrl: './form-input.component.html',
  imports: [CommonModule, MatIconModule, RxIconModule, FormsModule, ReactiveFormsModule],
})
export class FormInputComponent implements Field {
  config: FieldConfig;
  group: FormGroup;
}
